import { render } from "./AppSidebarContent.vue?vue&type=template&id=56cc348b&scoped=true"
import script from "./AppSidebarContent.vue?vue&type=script&lang=js"
export * from "./AppSidebarContent.vue?vue&type=script&lang=js"

import "./AppSidebarContent.vue?vue&type=style&index=0&id=56cc348b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56cc348b"]])

export default __exports__